/**
 * Two simultaneous June flash sales map to two market-price tiers via their Sanity `promotionId`.
 * `full` markets see the headline 48%-off message; `low` price markets see the price-drop message.
 * Gate on `promotionId` (the stable promotion identifier) — never on `promoCode`, which is the
 * mutable Braavos coupon string applied at checkout.
 */
export type FlashTier = 'full' | 'low';

export const FLASH_FULL_PROMOTION_ID = '48JUNE48';
export const FLASH_LOW_PROMOTION_ID = '48JUNE10';

export function getFlashTier(promotionId: string | null | undefined): FlashTier | null {
  if (promotionId === FLASH_FULL_PROMOTION_ID) {
    return 'full';
  }
  if (promotionId === FLASH_LOW_PROMOTION_ID) {
    return 'low';
  }
  return null;
}
